/* eslint-disable complexity */
/* eslint-disable max-statements */
import React, { useState } from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import Modal from "../../shared/modal";
import CloseButton from "../../shared/icon-cross";
import InputText from "../../shared/input-text";
import searchIcon from "./images/search-icon.svg";
import cancelIcon from "./images/cancel.svg";
import { NUMBER } from "../../../constants/app-constants";
import SectionList from "./section-list";
import SearchSuggestions from "./search-suggestions";
import { findSubstring } from "../../../utils/helpers/find-substring";
import GreenCheck from "./images/section-check.svg";
import { MINOR_IMPERFECTION } from "./constant";
const InspectionReportPopup = ({
    inspectionReportData,
    baseUrl,
    selectedInspectionCategoryData,
    onClose
}) => {
    const { report: { cards = [], detailReport = [] } = {} } = inspectionReportData || {};

    const noDefects = cards.length > 0 && parseInt(cards[0].title, 10) === 0;
    const [searchResults, setSearchResults] = useState([]);
    const [searchText, setSearchText] = useState("");
    const [showCancel, setShowCancel] = useState(false);

    const [selectedCategoryData, setSelecteCategoryData] = useState(selectedInspectionCategoryData || cards[0]);
    const close = () => {
        onClose();
        setShowCancel(false);
        // setIsInspectionReportOpenConnect(false);
        setSearchText("");
        setSearchResults([]);
    };

    const onTabChangeClick = (report) => {
        setSelecteCategoryData(report);
    };

    const getSearchResults = (searchValue) => {
        setSearchText(searchValue);
        if (searchValue.length >= NUMBER.TWO) {
            const resultList = [];
            detailReport.forEach((report) => {
                if (findSubstring(report.title, searchValue) && (report.imagesList || []).length) {
                    resultList.push({ ...report, imagesList: [...report.imagesList], key: MINOR_IMPERFECTION });
                } else {
                    const imperfectionsResultData = (report.imagesList || []).filter((elem) => findSubstring(elem.title, searchValue));
                    if (imperfectionsResultData && imperfectionsResultData.length) {
                        resultList.push({ ...report, imagesList: imperfectionsResultData, key: MINOR_IMPERFECTION });
                    }
                }

                if (findSubstring(report.title, searchValue) && report.subCategories && report.subCategories.length) {
                    resultList.push(report);
                } else if (report.subCategories && report.subCategories.length) {
                    const reportsResultData = report.subCategories.filter((elem) => findSubstring(elem.title, searchValue) && !elem.isDefective);
                    if (reportsResultData && reportsResultData.length) {
                        resultList.push({ ...report, subCategories: reportsResultData });
                    }
                }

            });
            return searchValue === "" ? [] : resultList;
        } else {
            return [];
        }
    };

    const onChangeHandler = (e) => {
        setShowCancel(true);
        const searchValue = e.target.value;
        if (!searchValue) {
            setShowCancel(false);
        }
        setSearchText(searchValue);
        const resultList = getSearchResults(searchValue);
        setSearchResults(resultList);
    };

    const handleClearSearch = () => {
        setSearchText("");
        setShowCancel(false);
    };
    const triggerInputEvent = () => {
    };
    const getSectionIcon = (index, {title}) => {
        if (index === NUMBER.ZERO && Number(title)) {
            return <p styleName="styles.imperfection">{Number(title)}</p>;
        } else {
            return <img src ={GreenCheck} />;
        }
    };
    const renderInspectionReport = () => {
        if (cards && cards.length) {
            return (<div styleName={"styles.inspectionReport"}>
                <div styleName={"styles.categorySection"}>
                    <ul>
                        {cards.map((report, index) => {
                            return (<li
                                onClick={() => onTabChangeClick(report)}
                                styleName={`${selectedCategoryData.key === report.key ? "styles.active" : ""}`}
                                key={report.key}
                            >
                                {report.displayName}
                                {getSectionIcon(index, report)}
                            </li>
                            );
                        }
                        )}
                    </ul>

                </div>
                { <div styleName={"styles.inspectionReportDetail"}>
                    <SectionList
                        activeTabKey={selectedCategoryData.key}
                        detailReport={detailReport}
                        cards={cards}
                        noDefects={noDefects}
                        // detailReport={detailReport}
                        baseUrl={baseUrl}
                    />
                </div>}
            </div>);
        }
        return <React.Fragment />;
    };

    const renderSearchResults = () => {
        return (<SearchSuggestions
            suggestions={searchResults}
            searchText={searchText}
            baseUrl={baseUrl}
        />);
    };

    return (
        <Modal isOpen={true} close={close}>
            <div styleName={"styles.modalWrap"}>
                <div styleName={"styles.headerWrap"}>
                    <div styleName={"styles.header"}>
                        <h4>Inspection report</h4>
                        <span styleName={"styles.close"}>
                            <CloseButton onClickHandler={close} type="black" />
                        </span>
                    </div>
                    <div styleName={"styles.flexCenter"}>
                        <div styleName={"styles.searchWrap"}>
                            <InputText
                                value={searchText}
                                onChange={onChangeHandler}
                                placeholder="Search for keywords"
                                onBlurCallback={triggerInputEvent}
                            />
                            <span styleName={"styles.searchIcon"}>
                                <img src={searchIcon} alt="Features" />
                            </span>
                            {!!showCancel && <span styleName={"styles.iconClose"}>
                                <img onClick={handleClearSearch} src={cancelIcon} alt="cancel" />
                            </span>}
                        </div>
                    </div>
                </div>
                {!searchText ? renderInspectionReport() : renderSearchResults()}
            </div>
        </Modal>
    );
};

InspectionReportPopup.propTypes = {
    setIsInspectionReportOpenConnect: PropTypes.func,
    getCustomDimesnionsion: PropTypes.func,
    carConditionAndInspectionReport: PropTypes.array,
    inspectionReportData: PropTypes.array,
    baseUrl: PropTypes.string,
    selectedInspectionCategoryData: PropTypes.object,
    onClose: PropTypes.func
};

export default InspectionReportPopup;
